module.exports = __webpack_public_path__ + "static/media/icn-ie.0c19ee9e.png";